import { createApp } from 'vue';
import { createPinia } from 'pinia';
import router from './router';
import App from './App.vue';
import { useUiStore } from './stores/ui';
import { useAuthStore } from './stores/auth';
import { captureLandingAttribution, hasUnattachedAttribution, postAttribution } from './utils/attribution';
import { initializeTheme } from './theme';
import './assets/main.css';

function isDynamicImportFailure(error: unknown): boolean {
  const message = error instanceof Error ? error.message : String(error ?? '');
  return /Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module/i.test(message);
}

initializeTheme();

const app = createApp(App);
const pinia = createPinia();
app.use(pinia);

const ui = useUiStore(pinia);
const requireReload = () => ui.requireReload();

// D009: capture landing UTMs once at boot, then attach any stored unattached
// payload for an authenticated session. Both are fire-and-forget and never
// block app mount.
captureLandingAttribution();
const auth = useAuthStore(pinia);
if (auth.isAuthenticated && hasUnattachedAttribution()) {
  void postAttribution(() => auth.getHeaders());
}

router.onError(error => {
  if (isDynamicImportFailure(error)) {
    requireReload();
  }
});

window.addEventListener('error', event => {
  if (isDynamicImportFailure(event.error ?? event.message)) {
    requireReload();
  }
});

window.addEventListener('unhandledrejection', event => {
  if (isDynamicImportFailure(event.reason)) {
    event.preventDefault();
    requireReload();
  }
});

app.use(router);
app.mount('#app');
